export default __webpack_public_path__ + "static/media/pitch.278abae5.webp";